import { APIDelete, APIGet, APIPost, APIUrl, AdminType, IAPIResponse } from "api/protocols";
import { CancelToken } from "axios";

export interface ICustomerFriend {
  email: string;
  first_name: string;
  full_name: string;
  id: number;
  initials: string;
  last_name: string;
  phone: string;
  customer_type: Array<{ title: string }>;
  member_code?: string | null;
  member_number?: string | null;
}

type TGetCustomerFriendsParams = {
  customer_id: number;
  search?: string;
};

type TPostCustomerFriendsParams = {
  customer_id: number;
  /** Add many users */
  friend_user_ids: Array<number>;
};

type TDeleteCustomerFriendParams = {
  customer_id: number;
  friend_user_id: number;
};

export async function GetCustomerFriends(
  params: TGetCustomerFriendsParams,
  useGlobalLoader: boolean,
  cancelToken?: CancelToken,
): Promise<IAPIResponse<Array<ICustomerFriend>>> {
  return await APIGet(APIUrl(AdminType.FacilityAdmin, "/customer/friend"), params, useGlobalLoader, cancelToken);
}

export async function PostFriends(params: TPostCustomerFriendsParams, useGlobalLoader?: boolean) {
  return await APIPost(APIUrl(AdminType.FacilityAdmin, "/customer/friend"), params, useGlobalLoader);
}

export async function DeleteFriend(params: TDeleteCustomerFriendParams, useGlobalLoader?: boolean) {
  return await APIDelete(APIUrl(AdminType.FacilityAdmin, "/customer/friend"), params, useGlobalLoader);
}

